import { render, staticRenderFns } from "./InventoryCustom.vue?vue&type=template&id=03351806&scoped=true&"
import script from "./InventoryCustom.vue?vue&type=script&lang=js&"
export * from "./InventoryCustom.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCustom.vue?vue&type=style&index=0&id=03351806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03351806",
  null
  
)

export default component.exports